import useSWR from "swr"
import axios from "axios"

const useUserNotifications = ({ userId, page, perPage }) => {
  return useSWR([`${process.env.REACT_APP_API_URL}/notifications`,], async ([url]) => {
    const searchParams = new URLSearchParams();

    if (userId) searchParams.append('user', userId);
    if (page) searchParams.append('page', page);
    if (perPage) searchParams.append('perPage', perPage);

    const params = searchParams.toString();

    const { data: { notifications, count } } = await axios.get(`${process.env.REACT_APP_API_URL}/notifications?${params}`);

    return { notifications, count };
  })
}

export default useUserNotifications;
